import "./polyfills/Event";

const setUpCloning = (sourceInput, targetInput, conditionInput) => {
  const enableField = function() {
    if (targetInput.tagName === "SELECT") {
      targetInput.disabled = false;
    } else {
      targetInput.readOnly = false;
    }
  };

  const disableField = function() {
    if (targetInput.tagName === "SELECT") {
      targetInput.disabled = true;
    } else {
      targetInput.readOnly = true;
    }
  };

  const performUpdate = function() {
    const wasDisabled = !!targetInput.disabled;
    if (!conditionInput || conditionInput.checked) {
      if (targetInput.type === "checkbox") {
        targetInput.checked = sourceInput.checked;
      } else {
        targetInput.value = sourceInput.value;
      }
      // Some browsers will not fire change events if the field is not enabled.
      if (wasDisabled) {
        enableField();
      }
      targetInput.dispatchEvent(new Event("change"));
      if (wasDisabled) {
        disableField();
      }
    }
  };

  const clearField = function() {
    if (targetInput.type === "checkbox") {
      targetInput.checked = false;
    } else {
      targetInput.value = "";
    }
    targetInput.dispatchEvent(new Event("change"));
  };

  const enableOrDisableField = function() {
    if (!conditionInput || conditionInput.checked) {
      performUpdate();
      disableField();
    } else {
      enableField();
      clearField();
    }
  };

  sourceInput && sourceInput.addEventListener("change", performUpdate);
  sourceInput && sourceInput.addEventListener("keyup", performUpdate);

  conditionInput &&
    conditionInput.addEventListener("change", enableOrDisableField);
};

export const initializeCloneFields = () => {
  // Set up field cloning for fields based on data attributes
  var cloneTargets = document.querySelectorAll(
    "input[data-clones], select[data-clones], textarea[data-clones]"
  );
  for (var i = 0; i < cloneTargets.length; i++) {
    var target = cloneTargets[i];
    var sourceId = target.getAttribute("data-clones");
    var source = document.getElementById(sourceId);
    var conditionId = target.getAttribute("data-clones-if");
    var condition = conditionId && document.getElementById(conditionId);
    setUpCloning(source, target, condition);
  }
};
